<div class="driver-view-container">
  <div class="trip-detail-popup-right">
    <img
      src="../../../assets/img/icons8-macos-close-60.png"
      class="close-icons"
      (click)="close()"
    />
  </div>
  <div class="driver-view" *ngIf="truckProfile">
    <div class="heading">
      <h3>Profile</h3>
    </div>
    <mat-divider></mat-divider>
    <form action="" class="trips-popups">
      <div class="row ml-0 mr-0">
        <div class="col-xl-9 col-lg-9 col-md-7 col-sm-12">
          <div class="row mt-3 ml-0 mr-0">
            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
              <div class="serial-no">Name:</div>
              <h6>{{ truckOwner.username }}</h6>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
              <h6>{{ truckOwner.mobile }}</h6>
              <h6>{{ truckOwner.registerInfo[0]?.email }}</h6>
            </div>
          </div>
          <div class="row mt-3 ml-0 mr-0">
            <div class="ol-xl-6 col-lg-6 col-md-12 col-sm-12">
              <div class="serial-no">Company Name:</div>
              <h6>{{ truckOwner.registerInfo[0]?.company_name }}</h6>
            </div>
            <div class="ol-xl-6 col-lg-6 col-md-12 col-sm-12">
              <div class="serial-no">GST:</div>
              <h6>
                {{ truckOwner.registerInfo[0]?.gst || 'NA' }}
                <span *ngIf="truckOwner.registerInfo[0]?.gst && (truckOwner.registerInfo[0]?.gst_verified || truckOwner.registerInfo[0]?.is_gst_verified)" style="margin-left: 8px;">
                  <img src="../../../assets/img/tick-verify.svg" title="Verified with Master India" style="width: 16px; vertical-align: middle;" />
                  <span style="color: #16a34a; font-size: 12px; font-weight: 500; margin-left: 4px;">Verified</span>
                </span>
              </h6>
            </div>
          </div>
          <div class="row mt-3 ml-0 mr-0">
            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
              <div class="serial-no">PAN:</div>
              <h6>
                {{ truckOwner.registerInfo[0]?.pan || 'NA' }}
                <span *ngIf="truckOwner.registerInfo[0]?.pan && (truckOwner.registerInfo[0]?.pan_verified || truckOwner.registerInfo[0]?.is_pan_verified)" style="margin-left: 8px;">
                  <img src="../../../assets/img/tick-verify.svg" title="Verified with Master India" style="width: 16px; vertical-align: middle;" />
                  <span style="color: #16a34a; font-size: 12px; font-weight: 500; margin-left: 4px;">Verified</span>
                </span>
              </h6>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
              <div class="serial-no">SMS Alert:</div>
              <h6>{{ truckOwner.registerInfo[0]?.sms_alert ? 'Enabled' : 'Disabled' }}</h6>
            </div>
          </div>
          <!-- <div class="row mt-3 ml-0 mr-0">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
              <div class="serial-no">Contact Details:</div>
              <h6>Siby Mining and Infrastucturre Private Limited</h6>
            </div>
          </div> -->
          <div class="row mt-3 ml-0 mr-0">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
              <div class="serial-no">Email:</div>
              <h6>{{ truckOwner.registerInfo[0]?.email }}</h6>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-5 col-sm-12 text-center">
          <div class="right-side image">
            <img
              src="{{ truckOwner.registerInfo[0]?.profile_pic }}"
              class="driverImg"
            />
          </div>
          <div class="info_container">
            <div class="gender_cont">
              <p>Gender</p>
              <p>{{ truckOwner.registerInfo[0]?.gender }}</p>
            </div>
            <div class="dob_cont">
              <p>DOB</p>
              <p>{{ truckOwner.registerInfo[0]?.dob | date : "dd-MM-yyyy" }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="heading mt-3">
        <h3>Bank Details</h3>
      </div>
      <mat-divider></mat-divider>
      <div class="row mt-3 ml-0 mr-0">
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12">
          <div class="serial-no">Account Name:</div>
          <h6>
            {{ truckOwner.registerInfo[0]?.account_details?.account_name }}
          </h6>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12">
          <div class="serial-no">Account Number:</div>
          <h6>
            {{ truckOwner.registerInfo[0]?.account_details?.accountr_number }}
          </h6>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12">
          <div class="serial-no">Bank Name:</div>
          <h6>{{ truckOwner.registerInfo[0]?.account_details?.bank_name }}</h6>
        </div>
      </div>
      <div class="row mt-3 ml-0 mr-0">
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12">
          <div class="serial-no">Mobile:</div>
          <h6>{{ truckOwner.registerInfo[0]?.mobile }}</h6>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12">
          <div class="serial-no">Branch:</div>
          <h6>
            {{ truckOwner.registerInfo[0]?.account_details?.branch_name }}
          </h6>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12">
          <div class="serial-no">IFSC Code:</div>
          <h6>{{ truckOwner.registerInfo[0]?.account_details?.ifsc_code }}</h6>
        </div>
      </div>
      <div class="heading mt-3">
        <h3>Billing Address</h3>
      </div>
      <mat-divider></mat-divider>
      <div class="row mt-3 ml-0 mr-0">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
          <div class="serial-no">Address Line 1:</div>
          <h6>
            {{ truckOwner.registerInfo[0]?.billing_address?.address_line }}
          </h6>
        </div>
      </div>

      <div class="row mt-3 ml-0 mr-0">
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12">
          <div class="serial-no">Landmark:</div>
          <h6>{{ truckOwner.registerInfo[0]?.billing_address?.area_name }}</h6>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12">
          <div class="serial-no">City:</div>
          <h6>{{ truckOwner.registerInfo[0]?.billing_address?.city }}</h6>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12">
          <div class="serial-no">State:</div>
          <h6>{{ truckOwner.registerInfo[0]?.billing_address?.state }}</h6>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12">
          <div class="serial-no">Pincode:</div>
          <h6>{{ truckOwner.registerInfo[0]?.billing_address?.pincode }}</h6>
        </div>
      </div>
      <!-- <div class="row mt-3 ml-0 mr-0">
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12">
          <div class="serial-no">PAN:</div>
          <h6>{{ truckOwner.registerInfo[0]?.pan }}</h6>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12">
          <div class="serial-no">TAN:</div>
          <h6>{{ truckOwner.registerInfo[0]?.tan }}</h6>
        </div>
      </div> -->
      <div class="row">
        <div class="fixed-btn">
          <button
            type="button"
            [class.spinner]="loading"
            [disabled]="loading"
            class="button"
            (click)="editUserTruck()"
          >
            Edit
          </button>
        </div>
      </div>
    </form>
  </div>

  <!--     Truck Edit    -->

  <div *ngIf="editTruckProfile" class="driver-view">
    <div class="container-fluid">
      <div class="heading">
        <h3>Profile</h3>
      </div>
      <mat-divider></mat-divider>
      <form [formGroup]="editTrucksFrom" class="admin-forms mt-3">
        <div class="row input-fileds-container">
          <div class="col-xl-9 col-lg-9 col-md-7 col-sm-12 adminUser_input">
            <div class="row mt-3 ml-0 mr-0">
              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                <mat-form-field>
                  <div class="serial-no">Name:</div>
                  <input matInput formControlName="username" required />
                  <mat-error>Please enter valid username </mat-error>
                </mat-form-field>
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-12 col-sm-12 d-flex align-items-center mobile"
              >
                <div *ngIf="!otpVerify" class="d-flex align-items-center w-100">
                  <mat-form-field class="flex-grow-1 m-0 mtb">
                    <input
                      placeholder="Mobile Number"
                      id="name"
                      class="ex2"
                      appTwoDigitDecimaNumber
                      formControlName="mobile"
                      matInput
                      minlength="10"
                      maxlength="10"
                      required
                      [readonly]="ismobileVerified"
                      (input)="onMobileInputChange()"
                    />
                    <mat-error>Please enter a valid mobile number</mat-error>
                  </mat-form-field>
                  <div
                    class="d-flex align-items-center ms-2"
                    *ngIf="mobileVerified === 0"
                  >
                    <img
                      class="verify_otp"
                      src="../../../assets/img/error.svg"
                    />
                    <a class="otp ms-2" (click)="Otpsend()">Send OTP</a>
                  </div>
                  <div class="otp-field" *ngIf="mobileVerified > 0">
                    <img src="../../../assets/img/tick-verify.svg" />
                  </div>
                </div>
                <div
                  class="col-xl-6 col-lg-6 col-md-12 col-sm-12"
                  *ngIf="otpVerify"
                >
                  <div class="group otp-field">
                    <ng-otp-input
                      class="adminUser_otp"
                      [config]="{ length: 4 }"
                      (onInputChange)="onOtpChange($event)"
                    ></ng-otp-input>
                    <img
                      src="../../../assets/img/error.svg"
                      *ngIf="otp_ver"
                      class="verify_otp"
                    />
                  </div>

                  <div class="otp-field" *ngIf="truckowner_verify_otp">
                    <img src="../../../assets/img/tick-verify.svg" />
                  </div>
                </div>
              </div>

              <div class="row mt-3 ml-0 mr-0">
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                  <div class="serial-no">Email:</div>
                  <input type="email" matInput formControlName="email" />
                </div>
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                  <mat-form-field class="mtb d-flex align-items-center">
                    <div class="serial-no">DOB:</div>
                    <input
                      matInput
                      [matDatepicker]="picker1"
                      [max]="minDob"
                      formControlName="dob"
                      (change)="onDateChnage(2)"
                      required
                      ng-pattern="/^(?:1[8-9]|[2-5][0-9]|60)$/"
                    />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="picker1"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #picker1></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="row mt-3 ml-0 mr-0">
              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                <div class="serial-no">Company Name:</div>
                <h6>{{ truckOwner.registerInfo[0]?.company_name }}</h6>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                <div class="serial-no">GST:</div>
                <h6>{{ truckOwner.registerInfo[0]?.gst }}</h6>
              </div>
            </div>
            <div class="row mt-3 ml-0 mr-0">
              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                <div class="serial-no">PAN:</div>
                <h6>{{ truckOwner.registerInfo[0]?.pan }}</h6>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 d-flex align-items-center">
                <div class="serial-no me-3" style="margin-right: 15px;">SMS Alert:</div>
                <mat-slide-toggle formControlName="sms_alert" class="custom-slide-toggle"></mat-slide-toggle>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-5 col-sm-12 text-center">
            <div class="right-side image">
              <img src="{{ truckImage }}" class="driverImg" />
              <div class="image-upload-area">
                <input
                  #uploadImage
                  type="file"
                  (change)="onChange($event)"
                  hidden
                />
              </div>
            </div>
            <div class="info_container">
              <div class="gender_cont">
                <div class="row mtb">
                  <div class="col-md-4 d-flex align-items-center">
                    <div class="">Gender</div>
                  </div>
                  <div class="col-md-8">
                    <div class="driver-truck">
                      <mat-form-field appearance="fill">
                        <mat-select formControlName="gender">
                          <mat-option>Select Gender</mat-option>
                          <mat-option value="male">Male</mat-option>
                          <mat-option value="female">Female</mat-option>
                          <mat-option value="others">Others</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>

              <div class="image-upload-area">
                <button class="mac" (click)="uploadImage.click()">
                  Update Profile
                </button>
                <input
                  #uploadImage
                  type="file"
                  (change)="onChange($event)"
                  hidden
                />
              </div>
            </div>
          </div>
        </div>

        <div class="row input-fileds-container">
          <div class="heading mt-3">
            <h3>Bank Details</h3>
          </div>
          <mat-divider></mat-divider>
          <div class="row mt-3 ml-0 mr-0">
            <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12">
              <mat-form-field>
                <div class="serial-no">Account Name:</div>
                <input matInput formControlName="account_name" required />
              </mat-form-field>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12">
              <mat-form-field>
                <div class="serial-no">Account Number:</div>
                <input matInput formControlName="accountr_number" required />
              </mat-form-field>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12">
              <mat-form-field>
                <div class="serial-no">Bank Name:</div>
                <input matInput formControlName="bank_name" required />
              </mat-form-field>
            </div>
          </div>

          <div class="row mt-3 ml-0 mr-0">
            <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12">
              <mat-form-field>
                <div class="serial-no">Branch:</div>
                <input matInput formControlName="branch_name" required />
              </mat-form-field>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12">
              <mat-form-field>
                <div class="serial-no">IFSC Code:</div>
                <input matInput formControlName="ifsc_code" required />
              </mat-form-field>
            </div>
          </div>
          <div class="heading mt-3">
            <h3>Billing Address</h3>
          </div>
          <mat-divider></mat-divider>
          <div class="row mt-3 ml-0 mr-0">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
              <div class="serial-no">Address Line 1:</div>
              <h6>
                {{ truckOwner.registerInfo[0]?.billing_address?.address_line }}
              </h6>
            </div>
          </div>
          <div class="row mt-3 ml-0 mr-0">
            <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12">
              <div class="serial-no">Landmark:</div>
              <h6>
                {{ truckOwner.registerInfo[0]?.billing_address?.area_name }}
              </h6>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12">
              <div class="serial-no">City:</div>
              <h6>{{ truckOwner.registerInfo[0]?.billing_address?.city }}</h6>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12">
              <div class="serial-no">State:</div>
              <h6>
                {{ truckOwner.registerInfo[0]?.billing_address?.state }}
              </h6>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12">
              <div class="serial-no">Pincode:</div>
              <h6>
                {{ truckOwner.registerInfo[0]?.billing_address?.pincode }}
              </h6>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="fixed-btn">
            <button
              type="button"
              [class.spinner]="loading"
              [disabled]="loading"
              (click)="updateTruckowner()"
              class="button"
            >
              Save
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
